import React from 'react'
import {
  LayoutBand,
  H3,
  H4,
  Subheading,
  Button,
  Grid,
  Cell,
  Separator,
  usePageWidth,
  Row,
  colors,
  Image,
  Bleed,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { TreeAppButtons } from '@fs/zion-mobile-app-buttons'
import signUpImage from './images/sign-up-image.webp'
import mobileAppsImg from './images/mobile-apps-image.webp'

export default function SignUp() {
  const { t } = useTranslation()
  const atPageWidth = usePageWidth()
  const isMobile = atPageWidth({ default: true, lg: false })

  return (
    <LayoutBand
      style={{
        background: isMobile
          ? `url("${mobileAppsImg}") center center / cover no-repeat`
          : `linear-gradient(to top, ${colors.gray05}, ${colors.gray00})`,
        minHeight: isMobile && '700px',
        overflow: 'hidden',
      }}
      marginX="xl"
    >
      {isMobile && <Separator size="xl" />}
      <Grid>
        <Cell alignY="middle" columns={atPageWidth({ default: 12, lg: 6, xl: 4 })}>
          <H3 size="H4" centered={isMobile}>
            {t(
              'nlihp.united-states.sign-up.heading',
              'Save your progress, and make new discoveries with FamilySearch access.'
            )}
          </H3>
          <Separator size="sm" />
          <Row alignX={isMobile ? 'center' : 'start'}>
            <Button emphasis="high" external to="/identity/signup/" color="gray" linkName="Sign up" target="_blank">
              {t('nlihp.united-states.sign-up.action', 'Sign up')}
            </Button>
          </Row>
        </Cell>
        {!isMobile && (
          <Bleed end top bottom columns={atPageWidth({ default: 12, lg: 6, xl: 8 })}>
            <Image
              src={signUpImage}
              alt=""
              aria-hidden="true"
              minHeight="500px"
              minWidth="900px"
              style={{ width: 'calc(100% + 300px)' }}
            />
          </Bleed>
        )}
      </Grid>
      {isMobile && <MobileApp />}
    </LayoutBand>
  )
}

function MobileApp() {
  const { t } = useTranslation()
  return (
    <>
      <Separator size="md" />
      <H4 size="H5" centered>
        {t('nlihp.united-states.sign-up.mobile-app.heading', 'Working on mobile?')}
        <Subheading>
          {t(
            'nlihp.united-states.sign-up.mobile-app.subheading',
            'The FamilySearch Tree app makes it easy to add to, edit, or share your own family’s history anywhere you can take a phone or tablet.'
          )}
        </Subheading>
      </H4>
      <Separator size="sm" />
      <TreeAppButtons centered newTab />
    </>
  )
}
